import { TenantCustomDomainAPI } from "@/redux/api/custom-domain-api/CustomDomainApi";
import Cookies from "js-cookie";

const getHeaders = async (hostname) => {
  let subdomain = hostname?.split(".")[0];
  const customTenant = Cookies.get("custom_tenant");

  if (
    !(
      hostname?.includes("padami.in") ||
      hostname?.includes("qaebe.online") ||
      hostname?.includes("localhost")
    ) &&
    !customTenant
  ) {
    const res = await TenantCustomDomainAPI(hostname);
    console.log("first if", res?.response);
    Cookies.set("custom_tenant", res?.response?.tenantCode, {
      path: "/",
      domain: res?.response?.customDomain,
      secure: true,
      sameSite: "Strict",
    });
    return {
      "Content-Type": "application/json",
      "X-Tenant-ID": res?.response?.tenantCode,
    };
  }

  if (customTenant) {
    console.log("customTenant if", customTenant);
    return {
      "Content-Type": "application/json",
      "X-Tenant-ID": customTenant,
    };
  } else if (
    subdomain === "www" ||
    subdomain === "localhost" ||
    hostname.includes("www.padami.in") ||
    hostname.includes("www.qaebe.online")
  ) {
    console.log("else if");
    return {
      "Content-Type": "application/json",
      "X-Tenant-ID": "superadmin",
    };
  } else {
    console.log("else ", subdomain);
    return {
      "Content-Type": "application/json",
      "X-Tenant-ID": subdomain,
    };
  }
};

export default getHeaders;
